interface CardHeaderProps {
    pageTitle?: string;
    pageSubTitle?: string;
}

const CardHeader = ({ pageTitle, pageSubTitle }: CardHeaderProps) => {
    return (
        <>
            {(pageTitle || pageSubTitle) && (
                <div className="flex flex-col items-center mb-8">
                    {pageTitle && (
                        <h2 className="font-bold text-5xl mt-0 tracking-tight font-lato">
                            {pageTitle}
                        </h2>
                    )}
                    {pageSubTitle && (
                        <p className="text-neutral-500 text-xl mt-3 font-lato">
                            {pageSubTitle}
                        </p>
                    )}
                </div>
            )}
        </>
    );
};

export default CardHeader;
